import Flex from '@components/Flex/Flex';
import { CircularProgress, lighten, styled } from '@mui/material';
import { ColorTypes } from '@customTypes/colors';

export const Container = styled(Flex)<{ color: ColorTypes }>(
  ({ theme, color }) => ({
    backgroundColor: theme.palette.backgroundColorOpacity[`${color}`][100],
    padding: theme.spacing(8),
    borderRadius: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    alignSelf: 'center',
  })
);

export const StyledCircularProgress = styled(CircularProgress)<{
  color: ColorTypes;
}>(({ theme, color }) => ({
  backgroundColor: lighten(
    theme.palette.backgroundColorOpacity[color][700],
    0.6
  ),
  borderRadius: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  '& .MuiCircularProgress-determinate': {
    borderRadius: '100%',
  },
}));

export const StyledTextContainer = styled(Flex)(() => ({
  flex: 1,
  position: 'absolute',
  flexDirection: 'column',
  justifyContent: 'center',
  textAlign: 'center',
}));
